class ProductionScanner {
  public static check(): boolean {
    return process.env.REACT_APP_IS_PRODUCTION === "true";
  }
}

export default ProductionScanner;
